import * as React from "react";
function XlIcon() {
    return React.createElement("path", { d: "M15.8376 29.2992L7.02563 20.4873L8.52559 18.9981L15.8376 26.31L31.4572 10.6797L32.9572 12.1796L15.8376 29.2992Z", fill: "currentColor" });
}
export default XlIcon;
//# sourceMappingURL=Xl.js.map